import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useGenerateQuestionsYouTube = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return useMutation(
    trpc.questions.generateFromYoutube.mutationOptions({
      onSuccess: (_, { id }) => {
        toast.success("Questions are being generated");
        queryClient.invalidateQueries({
          queryKey: trpc.questions.getWithOptions.queryKey({ id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.progress.getStudySetProgress.queryKey({ id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.questions.getWithFileNames.queryKey({ id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.users.getPlanLimit.queryKey(),
        });
      },
      onError: (error) => {
        console.error("Failed to generate questions", error);
        toast.error(error.message);
      },
    }),
  );
};
